import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { MaintenanceStatusSchema } from '../../../../dashboard/components/utility/schema-defs';
import { UpdateStatusRequest } from '../../../models';
import { getPostMaintenanceStatus } from '../../actions/actionType/schedule-maintenance/PostMaintenanceStatusTypes';
import {
  cleargetMaintenanceStatus,
  getMaintenanceStatusFailure,
  getMaintenanceStatusStart,
  getMaintenanceStatusSuccessful
} from '../../actions/sagaActions/schedule-maintenance/PostMaintenanceStatusSagaActions';
import {
  GetMaintenanceStatusFailurePayload,
  GetMaintenanceStatusRequest
} from '../../actions/types/schedule-maintenance/PostMaintenanceStatusTypes';

/**
 * Call Get metric summary by API
 * @returns api response
 */
export async function callGetMaintenanceStatusApi(
  data: UpdateStatusRequest
) {
  return apiWrapper.put(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance/${data.maintenanceName}`,
    data
  );
}

export function* getMaintenanceStatusApi({
  requestObject
}: GetMaintenanceStatusRequest) {
  yield put(cleargetMaintenanceStatus());
  yield put(getMaintenanceStatusStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetMaintenanceStatusApi, requestObject);

    if (isError) {
      throw error;
    }

    const apiResponse = MaintenanceStatusSchema.validate(data, {
      abortEarly: true
    });
    if (apiResponse.error) {
      throw new Error('No Response');
    } else {
      yield put(getMaintenanceStatusSuccessful(data));
    }
  } catch (error: any) {
    const obj: GetMaintenanceStatusFailurePayload = {
      error: 'Unable to update Maintenance Status'
    };
    yield put(getMaintenanceStatusFailure(obj));
  }
}
/**
 * Saga Effect to consider latest request
 */
export function* GetMaintenanceStatusSaga() {
  yield takeLatest(
    getPostMaintenanceStatus.POST_MAINTENANCE_STATUS_REQUEST,
    getMaintenanceStatusApi
  );
}

export const getMaintenanceStatusSaga = [fork(GetMaintenanceStatusSaga)];
